import React, { useRef } from 'react';
import { ICONS } from '@ohif/ui';

interface FileInputProps {
  id: string;
  name: string;
  label: string;
  placeholder?: string;
  isFolderInput?: boolean;
  accept?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  displayText?: string;
  isDarkMode?: boolean;
}

const FileInput: React.FC<FileInputProps> = ({
  id,
  name,
  label,
  placeholder = 'Select File',
  isFolderInput = false,
  accept,
  onChange,
  onBlur,
  displayText,
  isDarkMode = false,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDivClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <div className="formCol">
      <div className="form__Field">
        <label className="form__label" htmlFor={id}>
          {label}
          <span className="required-asterisk">*</span>
        </label>
        <input
          type="file"
          id={id}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          style={{ display: 'none' }}
          ref={inputRef}
          multiple
          {...(isFolderInput ? { webkitdirectory: '', directory: '' } : {})}
          accept={accept}
        />
        <div
          onClick={handleDivClick}
          className="customInput"
          style={isDarkMode ? { backgroundColor: '#333', color: '#fff' } : { backgroundColor: '#fff', color: '#000' }}
        >
          <img src={isFolderInput ? `${ICONS.browseFolder}` : `${ICONS.browse}`} alt="Browse" />
          {displayText}
        </div>
      </div>
    </div>
  );
};

export default FileInput;
